import { z } from 'zod';
import { FlowLookbackDurationUnit } from '../../../duration/duration.js';
import { BaseFlowBlockSchema } from '../block.js';
import { FlowConsumerOfPatientSchema } from '../consumer.js';
import { FlowBlockType } from '../type.js';
const MAX_DOCUMENT_LIMIT = 10;
export const FlowDocumentExtractBlockConfigSchema = z.object({
    patient: FlowConsumerOfPatientSchema({ isRequired: false }),
    titleFilters: z.array(z.string()).default([]),
    typeFilters: z.array(z.string()).default([]),
    documentLimit: z
        .number()
        .positive()
        .int()
        .max(MAX_DOCUMENT_LIMIT, `Document limit cannot exceed ${String(MAX_DOCUMENT_LIMIT)}`),
    lookbackDuration: z.object({
        value: z.number().positive().int(),
        unit: z.enum(FlowLookbackDurationUnit),
    }),
    encounterId: z.string().optional(),
});
export const FlowDocumentExtractBlockSchema = BaseFlowBlockSchema.extend({
    type: z.literal(FlowBlockType.DocumentExtract),
    config: FlowDocumentExtractBlockConfigSchema,
});
//# sourceMappingURL=config.js.map